import React from 'react';

const CreateTickIcon = () => {
  return (
<svg width="71" height="71" viewBox="0 0 71 71" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M35.5 71C55.1061 71 71 55.1061 71 35.5C71 15.8939 55.1061 0 35.5 0C15.8939 0 0 15.8939 0 35.5C0 55.1061 15.8939 71 35.5 71ZM52.6134 27.4731C53.6946 25.9866 53.3659 23.9052 51.8794 22.8241C50.3929 21.7429 48.3114 22.0716 47.2303 23.5581L31.7711 44.8145L23.4315 36.4748C22.1318 35.1751 20.0245 35.1751 18.7248 36.4748C17.4251 37.7745 17.4251 39.8817 18.7248 41.1815L29.8185 52.2752C30.5068 52.9635 31.4618 53.3159 32.4322 53.2398C33.4026 53.1637 34.291 52.6666 34.8634 51.8794L52.6134 27.4731Z" fill="#01A768"/>
</svg>






  );
};

export default CreateTickIcon;